(function() { module.exports = this["wp"]["hooks"]; }());